import { render, staticRenderFns } from "./nao-eh-convenio.vue?vue&type=template&id=aba5e012&scoped=true&"
import script from "./nao-eh-convenio.vue?vue&type=script&lang=js&"
export * from "./nao-eh-convenio.vue?vue&type=script&lang=js&"
import style0 from "./nao-eh-convenio.vue?vue&type=style&index=0&id=aba5e012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba5e012",
  null
  
)

export default component.exports